/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Component, ViewEncapsulation, Renderer, ElementRef, Input } from '@angular/core';
export class AvatarText {
/**
 * 用户CSS样式
 */
class: string;
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 */
constructor(private _renderer: Renderer,
private _elementRef: ElementRef) {

    }
/**
 * The underlying host native element
 * @return {?}
 */
getHostElement(): HTMLElement {
        return /** @type {?} */(( this._elementRef.nativeElement as HTMLElement));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-avatar-text',
    template: `<ng-content></ng-content>`,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'class': [{ type: Input },],
};
}

function AvatarText_tsickle_Closure_declarations() {
/** @type {?} */
AvatarText.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AvatarText.ctorParameters;
/** @type {?} */
AvatarText.propDecorators;
/**
 * 用户CSS样式
 * @type {?}
 */
AvatarText.prototype.class;
/** @type {?} */
AvatarText.prototype._renderer;
/** @type {?} */
AvatarText.prototype._elementRef;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
